import React from 'react';
import "./custom.css";
function BlogContent({text}) {
  return (
    <div className="blogP">
      {text}
    </div>
  );
}
export default BlogContent;
